














































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ComprehensiveExportDialog extends Vue {
  @Prop()
  private ifShow: any;
  private projectOptions: string[] = [
    "舌诊",
    "面诊",
    "脉诊",
    "目诊",
    "掌诊",
    "体质辨识",
  ];
  private selectedItems: string[] = [...this.projectOptions];
  private time: string[] = [];
  private get visible() {
    return this.ifShow;
  }
  private set visible(val) {
    this.$emit("update:ifShow", val);
  }
  private cancel() {
    this.visible = false;
  }
  /**
   * @description 确认导出。后端接口未就绪，仅做前端校验，不发起实际导出请求。
   */
  private confirm() {
    if (!this.selectedItems.length) {
      this.$message.warning("请选择导出项目");
      return;
    }
    if (!this.time || this.time.length !== 2) {
      this.$message.warning("请选择采集时间");
      return;
    }
    this.visible = false;
  }
}
